<template>
  <div class="select-item-box" >
    <div class="relative">
      <h5>{{ title }}</h5>
      <!-- <span
        v-if="canBeCleared && selectUser && selectUser.id"
        class="clear-assigned flex center-all"
        @click="clearSelected"
        @click.native.stop
        @click.stop >
        <span>Clear</span>
        <SBIcon
          :icon="SBIconList.CLOSE_THIN"
          :color="SBColors.blackUltralight"
          :size="8" />
      </span> -->
      <b-button
        v-if="canBeCleared && selectUser && selectUser.id"
        class="clear-assigned flex center-all"
        @click="clearSelected"
        @click.stop >
        <span>Clear</span>
      </b-button>
    </div>
    <div
      v-if="allItemsList.length > 5"
      class="search-input-wrapper">
      <b-form-input
        ref="searchTermInputRef"
        v-model="searchTerm"
        type="text"
        :placeholder="searchTermPlaceholder"/>
      <SBIcon
        v-if="searchTerm"
        :icon="SBIconList.CLOSE_THIN"
        :color="SBColors.blackUltralight"
        :hover-icon-color="SBColors.blackPrimary"
        :size="8"
        :hover-size="16"
        :pointer="true"
        @click="clearSearchTerm"
        @click.native.stop />
    </div>
    <ul
      ref="itemListWrapperRef"
      class="branch-list">
      <li
        v-for="(item, index) in searchResults"
        :key="index"
        class="flex flex-align-center"
        :class="{selected: selectedId === index}"
        @click="selectItem(item)"
        @mouseover="mouseSelect(index)"
        @mouseout="deselect()" >
        <SBAvatarImage
          class="item-icon no-shrink"
          :name="item.id ? item.name : '?'"
          :image="item.avatar"
          :available="item.ai_assistant || (item.available && item.online)"
          :show-availability-status="showAvailabilityStatus && !!item.id" />
        <span
          class="greedy"
          :inner-html.prop="item.name | boldMatch(searchTerm)" />
        <span
          v-if="
            selectByProvided ? selectUser && selectUser.id && (selectUser.id === item.id) : assignedTo === item.id"
          class="sb2-icon done-tick-blue size-xxs"/>
      </li>
      <p
        v-if="searchResults.length === 0"
        class="no-match" >
        <span class="emoji-fix">😐</span> We couldn't find anything for <b>{{ searchTerm }}</b>.
      </p>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SBAvatarImage from '../../common/AvatarImage';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';


/**
 * This is copied from src/components/business/branch/selectItem.vue
 * Components should be refactored and combined into one generic search+select component with slots and props...
 *
 */

export default {
  name: 'AssignConversationAssignMenu',
  components: {
    SBIcon,
    SBAvatarImage,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Assign to',
    },
    searchTermPlaceholder: {
      type: String,
      required: false,
      default: 'Search',
    },
    /**
     * Prevents the search input field to be focused when component is mounted.
     * NOTE: This is veeeeeery important to be part of the component because we are using this component on a multiple places and one of them is in the slide in menu on
     *       the part that should not be visible at start and it is positioned on the right. Auto focus was causing the overflow hidden area to be moved right so this focused field is shown and it should not be just yet.
     *       That is why this should not always focus on mounted.
     */
    preventInitialFocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * By default the selected user is user assigned to a conversation. with this param we can override this and use this component for different needs.
     * TODO: During rewrite make this dynamic so it is not bound to the assigned feature but to this parameter by default so we will not even need this parameter and selectUser will be mandatory.
    */
    selectByProvided: {
      type: Boolean,
      default: false,
      required: false,
    },
    selectUser: {
      type: Object,
      required: false,
      default: () => {},
    },
    showAvailabilityStatus: {
      type: Boolean,
      default: true,
      required: false,
    },
    hideUnassigned: {
      type: Boolean,
      required: false,
      default: false,
    },
    canBeCleared: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      searchTerm: '',
      SBIconList,
      SBColors,
      selectedId: null,
      searchUsed: true, // Set this to false if we decide to enable arrow keys only after the search has been used.
      mouseSelectAllowed: true,
      mouseResetTimeout: null,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
      currentOrganisationMembers: 'organisation/currentOrganisationMembers',
    }),
    allItemsList() {
      return [
        {
          id: '',
          name: 'Unassigned',
          avatar: '',
        },
        ...this.currentOrganisationMembers.filter(member => member.businesses.includes(this.activeConversation.business_id)),
      ];
    },
    searchResults() {
      if (this.hideUnassigned || this.searchTerm) {
        // Unassigned is the first item and it should not be used in search.
        return this.allItemsList.slice(1).filter(m => m.name && m.name.toLowerCase().indexOf(this.searchTerm) !== -1);
      }
      return this.allItemsList;
      // return this.currentOrganisation.businesses.filter(business => business.name.toLowerCase().includes(this.searchTerm.toLowerCase()) || business.phone.includes(this.searchTerm));
    },
    assignedTo() {
      return this.activeConversation.user_id || '';
    },
  },
  watch: {
    searchTerm() {
      this.searchUsed = true;
      this.selectedId = 0;
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    if (this.$refs.searchTermInputRef && !this.preventInitialFocus) {
      this.focusSearchTermInput();
    }
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    clearSearchTerm() {
      this.searchTerm = '';
    },
    focusSearchTermInput() {
      setTimeout(() => {
        this.$refs.searchTermInputRef.focus();
      }, 100);
    },
    selectItem(item) {
      this.$emit('item-selected', item);
    },
    clearSelected() {
      this.$emit('item-selected', null);
    },
    mouseSelect(itemId) {
      if (this.mouseSelectAllowed) {
        this.select(itemId);
      }
    },
    select(itemId) {
      this.selectedId = itemId;
      this.scrollIntoViewIfNeeded(this.$refs.itemListWrapperRef.children[itemId]);
    },
    deselect() {
      if (this.mouseSelectAllowed) {
        this.selectedId = null;
      }
    },
    scrollIntoViewIfNeeded(target) {
      const rectParent = target.parentElement.getBoundingClientRect();
      const rect = target.getBoundingClientRect();
      this.$nextTick(() => {
        const pseudoElementStyle = getComputedStyle(target.parentElement);
        const borderTopWidth = Number.parseInt(pseudoElementStyle.borderTopWidth.replace('px', ''), 10);
        const topPadding = Number.parseInt(pseudoElementStyle.paddingTop.replace('px', ''), 10);
        const parentTop = rectParent.top + borderTopWidth + topPadding;
        const parentBottom = rectParent.bottom + borderTopWidth + topPadding;
        if (rect.top < parentTop) {
          target.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
        } else if (rect.bottom > parentBottom) {
          target.scrollIntoView({ block: 'end', inline: 'nearest', behavior: 'smooth' });
        }
      });
    },
    /**
     * Sets flag to not react on mouse events on the li items. If this is off and mouse is above a li item and we initiate changes with the arrow keys
     * then at some point the list will scroll and the mouse event will be trigered which will cause unwanted result.
     */
    preventMouseAction() {
      this.mouseSelectAllowed = false;
      clearTimeout(this.mouseResetTimeout);
      this.mouseResetTimeout = setTimeout(() => {
        this.mouseSelectAllowed = true;
      }, 1000);
    },
    handleKeyDown(event) {
      switch (event.keyCode) {
        case 37: // LEFT
          this.preventMouseAction();
          if (this.searchUsed && this.selectedId > 0) {
            this.select(this.selectedId - 1);
          }
          event.preventDefault();
          break;
        case 38: // UP
          this.preventMouseAction();
          if (this.searchUsed && this.selectedId > 0) {
            this.select(this.selectedId - 1);
          }
          event.preventDefault();
          break;
        case 39: // RIGHT
          this.preventMouseAction();
          if (this.searchUsed && this.selectedId === null) {
            this.select(0);
          } else if (this.searchUsed && this.selectedId < this.searchResults.length - 1) {
            this.select(this.selectedId + 1);
          }
          event.preventDefault();
          break;
        case 40: // DOWN
          this.preventMouseAction();
          if (this.searchUsed && this.selectedId === null) {
            this.select(0);
          } else if (this.searchUsed && this.selectedId < this.searchResults.length - 1) {
            this.select(this.selectedId + 1);
          }
          event.preventDefault();
          break;
        case 13: // ENTER
          if (this.selectedId >= 0) {
            this.selectItem(this.searchResults[this.selectedId]);
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.select-item-box {
  width: 297px;
  font-size: 14px;

  h5 {
    text-align: center;
    font-weight: 500;
    padding: 15px 16px 0;
  }

  .clear-assigned {
    line-height: 1;
    position: absolute;
    top: 12px;
    right: 14px;
    color: $blackPrimary;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    max-height: 24px;
    padding: 6px 10px !important;

    & > span {
      // margin-right: 7px;
    }
  }

  .search-input-wrapper {
    position: relative;
    // border-bottom: solid 1px #e0e7e9;

    input {
      position: relative;
      padding: 5px 26px 5px 8px;
      margin: 15px 16px 0;
      width: calc(100% - 30px);
      border-radius: 5px;
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1) !important;
      border: solid 1px #cfd8dc !important;
      background-color: #ffffff !important;
      height: 26px !important;

      &:focus {
        box-shadow: 0 0 0 3px #bfdeff !important;
      }
    }

    .sb-icon {
      position: absolute;
      top: 5px;
      right: 20px;
    }
  }

  .branch-list {
    margin: 0;
    margin-top: 15px;
    padding: 7px 0;
    border-radius: 0 0 5px 5px;
    border-top: solid 1px #e0e7e9;
    overflow: hidden;
    max-height: 200px;
    overflow-y: auto;

    li {
      padding: 10px 16px;
      .item-icon {
        margin-right: 10px;
        display: inline-block;
        width: 20px;
      }

      &.selected {
        background: $mainBg;
        cursor: pointer;
      }
    }

    .branch-not-found {
      display: block;
      padding: 0 16px;
    }
  }

  .no-match {
    font-size: 14px;
    padding: 10px 12px;
  }
}
</style>
